import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SLIDES = [
  { src: "/founders/slide-1.jpg", alt: "Alessia Follari e Alessandra Floridia — FArLight" },
  { src: "/founders/slide-2.jpg", alt: "FArLight — la luce in movimento, bianco e nero" },
];

export const HeroSlider = () => {
  const [i, setI] = useState(0);
  useEffect(() => { const id = setInterval(() => setI((v) => (v + 1) % SLIDES.length), 4500); return () => clearInterval(id); }, []);
  const go = (d) => setI((v) => (v + d + SLIDES.length) % SLIDES.length);
  return (
    <div data-testid="hero-slider" className="group relative aspect-[4/5] sm:aspect-[5/4] lg:aspect-[4/5] overflow-hidden rounded-sm border border-ink/10 bg-black shadow-[0_24px_60px_rgba(42,39,38,0.10)]">
      {SLIDES.map((s, k) => (
        <img key={s.src} src={s.src} alt={s.alt} className={`bw-hover absolute inset-0 w-full h-full object-cover ${k === i ? "opacity-100" : "opacity-0"}`} loading={k === 0 ? "eager" : "lazy"} />
      ))}
      <button type="button" data-testid="hero-slider-prev" aria-label="Precedente" onClick={() => go(-1)} className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/80 hover:bg-white text-ink flex items-center justify-center transition-colors"><ChevronLeft className="w-4 h-4" /></button>
      <button type="button" data-testid="hero-slider-next" aria-label="Successiva" onClick={() => go(1)} className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/80 hover:bg-white text-ink flex items-center justify-center transition-colors"><ChevronRight className="w-4 h-4" /></button>
      <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2">
        {SLIDES.map((_, k) => <button key={k} type="button" data-testid={`hero-slider-dot-${k}`} aria-label={`Foto ${k + 1}`} onClick={() => setI(k)} className={`w-2 h-2 rounded-full transition-colors ${k === i ? "bg-[#C5A059]" : "bg-white/70"}`} />)}
      </div>
    </div>
  );
};
